import messages from "./AppFooter.json"

export default {
    name: 'main-footer',

    i18n : messages
  }